module.exports = __webpack_public_path__ + "img/excellence_in.c27c5bfb.png";